import Vue from "vue";
import VueRouter from "vue-router";
import OrderForm from "@osteon-nexus-ordering/nexus-ordering";
import NullLanding from "@/components/NullLanding";
import CompletedOrder from "@/components/CompletedOrder";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "nullLanding",
    component: NullLanding,
  },
  {
    path: "/callback",
    name: "authCallback",
    component: NullLanding,
  },
  {
    path: "/order/:uid",
    name: "existingOrderForm",
    props: true,
    component: OrderForm,
  },
  {
    path: "/complete/:uid",
    name: "caseOverview",
    props: true,
    component: CompletedOrder,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
